export const FEATURE_WALKTHROUGH_KEYS = {
  ds_binding: "ab_ds_binding_enabled",
  ds_schema: "ab_ds_schema_enabled",
  binding_widget: "binding_widget",
  env_walkthrough: "ab_env_walkthrough_enabled",
  // Signposting keys
  back_to_canvas: "back_to_canvas",
  add_table_widget: "add_table_widget",
  switch_to_widget: "switch_to_widget",
  deploy: "deploy",
  create_query: "create_query",
  add_datasouce: "add_datasouce",
  connect_data: "connect_data",
};
